import React, { useState } from 'react';
import ReactGA from 'react-ga4';

import { ClickAwayListener } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import { useDispatch } from 'react-redux';
import { changeInfoModal } from '../../store/ui/ui.slice';

import Section from '../section/section.component';

import './help-drawer.styles.scss';
import CbfToggle from './cbf-toggle/cbf-toggle.component';

export default function HelpDrawer() {
  const [helpVisible, setHelpVisible] = useState(false);
  const dispatch = useDispatch();

  const handleClickAway = () => {
    setHelpVisible(false);
  };

  const handleToggleOpen = () => {
    if (!helpVisible) {
      ReactGA.event({
        category: "User Interaction",
        action: "Opened Help Menu",
      });
    }

    setHelpVisible(!helpVisible);
  };

  const handleSelect = (choice) => {
    ReactGA.event({
        category: "User Interaction",
        action: "Clicked Help Option",
        label: choice
    });

    if (choice === 'report') {
      ReactGA.event({
        category: 'User Interaction',
        action: 'open_report'
      });
      window.open('https://www.rand.org/pubs/tools/TLA386-9.html', '_blank');
    } else {
      setHelpVisible(!helpVisible);
      dispatch(changeInfoModal(choice));
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div>
        <Section
          id='help-drawer-container'
          className={helpVisible ? '' : 'help-hidden'}
        >
          <div id='help-icon' onClick={handleToggleOpen}>
            {helpVisible ? <CloseIcon /> : <HelpOutlineIcon />}
          </div>

          <div id='help-options'>
            <ul>
              <li onClick={() => handleSelect('purposeOfTool')}>
                Purpose of the Tool
              </li>
              <li onClick={() => handleSelect('howToUseTool')}>
                How to Use the Tool
              </li>
              <li onClick={() => handleSelect('dataAndTech')}>
                Data and Technical Information
              </li>
              <li onClick={() => handleSelect('report')}>See the Report</li>
              <li onClick={() => handleSelect('changelog')}>
                Recent Tool Changes
              </li>
            </ul>

            <CbfToggle />
          </div>
        </Section>
      </div>
    </ClickAwayListener>
  );
}
